import { licenseInitialData } from "./InitialData"

export type LicenseTableType = {
  licenseTypeID: number
  name: string
  product: string
  total: number
  productID: number
  assigned: number
  membersAssigned: []
  content: string
}

const convertToLicenseReport = (data: licenseInitialData): LicenseTableType[] => {

  const licenses = data?.licenses ?? []

  const licenseData = licenses.map(license => ({
    licenseTypeID: license.licenseTypeID ?? 0,
    name: license.name ?? '',
    product: license.product ?? '',
    productID: license.productID ?? 0,
    total: license.total ?? 0,
    assigned: license.assigned ?? 0,
    membersAssigned: license.membersAssigned ?? [],
    content: license.content ?? ''
  }));

  return licenseData;
  
}

export const LicenseTableData = (data: licenseInitialData): LicenseTableType[] => {
  return convertToLicenseReport(data)
}
